import "jquery-validation";

$(document).ready(function() {
  // ============================
  // ✅ Form Validation Logic
  // ============================
  $("#new_grievance").validate({
    errorClass: "error_message",

    rules: {
      "grievance[name]": {
        required: true,
        minlength: 3,
        maxlength: 40
      },
      "grievance[email]": {
        required: true,
        email: true
      },
      "grievance[phone_number]": {
        required: true,
        number: true,
        minlength: 10,
        maxlength: 10
      },
      "grievance[subject]": {
        required: true
      },
      "grievance[message]": {
        required: true
      }
    },

    messages: {
      "grievance[name]": {
        required: "Please enter your name",
        minlength: "Please enter a valid name",
        maxlength: "Name should not have more than 40 chars"
      },
      "grievance[email]": {
        email: "Please enter a valid email",
        required: "Please enter your email"
      },
      "grievance[phone_number]": {
        required: "Please enter 10 digit mobile number",
        number: "Please enter a numeric value",
        minlength: "Please enter 10 digit mobile number",
        maxlength: "Please enter 10 digit mobile number"
      },
       "grievance[subject]": {
        required: "Please enter a brief subject"
      },
       "grievance[message]": {
        required: "Please enter your detailed issue"
      },
    },

    submitHandler: function(form) {
      if ($(form).valid()) {
        form.submit();
      }
    }
  });
});
